export interface ControleQualidadeItem {
    CZ04FILIAL: string;
    CZ04CODIGO: string;
    CZ04LOTE: string;
    DZ04DATA: Date | undefined;
    CZ04HORA: string;
    CZ04STATUS: string;
    CZ04MOTIVO: string;
    CZ04USER: string;
    CZ04TURNO: string;
    CZPRGENERI: string;
    CUSRNOME: string;
    CSB8PRODUTO:string;
    CSB1DESC:string;
  }
  
  export interface ControleQualidadeLista {
    items: Array<ControleQualidadeItem>
  }
  
  export interface ControleQualidadeCadastroItem {
    CZ04LOTE: string;
    CB1COD: string;
    CB1DESC: string;
    CZ04STATUS: string;
    CZ03ENVLOT: string;
    NQTD: number;
    favorite: Array<string>;
  }
  
  export interface ControleQualidadeCadastroLista {
    items: Array<ControleQualidadeCadastroItem>;
    status: string;
    motivo: string;
  }

  export const getControleQualidadeCadastroListaDefault = (): ControleQualidadeCadastroLista => {
    return {
      items: [],
      status: '',
      motivo: '',
    };
  };
